<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <TransitionRoot as="template" :show="modelValue">
        <Dialog
            as="div"
            class="fixed inset-0 z-10 overflow-y-auto"
            @close="closeModal"
        >
            <div
                class="flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0"
            >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <DialogOverlay
                        class="fixed inset-0 bg-iron-500 bg-opacity-75 transition-opacity"
                    />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span
                    class="hidden sm:inline-block sm:h-screen sm:align-middle"
                    aria-hidden="true"
                    >&#8203;</span
                >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100 translate-y-0 sm:scale-100"
                    leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        class="inline-block transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle"
                    >
                        <div
                            class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block"
                        >
                            <button
                                type="button"
                                class="rounded-md bg-white text-iron-400 hover:text-iron-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                @click="closeModal"
                            >
                                <span class="sr-only">Close</span>
                                <XCircleIcon
                                    class="h-6 w-6"
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                        <div class="sm:flex sm:items-start">
                            <div
                                class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-error-100 sm:mx-0 sm:h-10 sm:w-10"
                            >
                                <ExclamationTriangleIcon
                                    class="h-6 w-6 text-error-600"
                                    aria-hidden="true"
                                />
                            </div>

                            <div
                                class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left"
                            >
                                <DialogTitle
                                    as="h3"
                                    class="text-lg font-medium leading-6 text-iron-900"
                                >
                                    {{
                                        $t(
                                            "event_types.event_detail.remove_time_slot.title",
                                        )
                                    }}
                                </DialogTitle>
                                <div class="mt-2">
                                    <p class="text-sm text-iron-500">
                                        {{
                                            $t(
                                                "event_types.event_detail.remove_time_slot.description",
                                                {
                                                    from: formatTime(
                                                        event.start,
                                                    ),

                                                    to: formatTime(event.end),
                                                },
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                            <button
                                type="button"
                                class="inline-flex w-full justify-center rounded-md border border-transparent bg-error-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-error-700 focus:outline-none focus:ring-2 focus:ring-error-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                                @click="excludeDate"
                            >
                                {{ $t("remove") }}
                            </button>

                            <button
                                type="button"
                                class="mt-3 inline-flex w-full justify-center rounded-md border border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:text-iron-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
                                @click="closeModal"
                            >
                                {{ $t("cancel") }}
                            </button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts" setup>
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import {
    XCircleIcon,
    ExclamationTriangleIcon,
} from "@heroicons/vue/24/outline";
import route from "ziggy-js";
import { router } from "@inertiajs/vue3";
import { format } from "date-fns";
const props = defineProps({
    modelValue: Boolean,
    event: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits([
    "update:modelValue",
    "delete-event",
    "excluded-date",
]);

const excludeDate = () => {
    router.post(
        route("app.event-types.excluded-dates.store", {
            eventType: props.event.event_type_id,
        }),
        {
            start: props.event.start,
            end: props.event.end,
        },
        {
            onFinish: () => {
                emit("excluded-date");
                closeModal();
            },
        },
    );
    closeModal();
};

function formatTime(date: string) {
    return format(new Date(date), "HH:mm");
}

const closeModal = () => {
    emit("update:modelValue", false);
};
</script>
